import { Route, Routes, Navigate } from "react-router-dom";

import routes from "../routes";

function Auth() {
    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/auth") {
                return (
                    <Route path={prop.path} element={prop.component} key={key} exact />
                );
            } else {
                return null;
            }
        });
    };

    return (
        <div className="wrapper">
		<div className="section-authentication-login d-flex align-items-center justify-content-center mt-4">
        <Routes>{getRoutes(routes)}<Route path="/" element={<Navigate to="/auth/login" replace />} /></Routes>
		</div>
	</div>
        

    );
}

export default Auth